import React from "react";
import pifLogo from "../assets/images/pif-logo.png";

function PifLogo() {
   return <img src={pifLogo} alt="PIF" className="pif-logo" />;
}

export default PifLogo;



